'use strict';

var App = require('app');
var AppState = require('app_state');
var AlarmGroupList = require('components/devices/views/alarm/alarm_group_list_view');
var CommonViews = require('components/common/views');
var HomeController = require('components/home/home_controller');
var I18N = require('utils/i18n');

var AlarmOccurrenceController = Marionette.Object.extend({
    groupBy: {
        fieldID: 'alarm_id',
        fieldName: 'alarm_name',
        sortCol: 'triggered_time',
        defaultReversed: ['triggered_time', 'corrected_time'],
    },

    groupSettings: [
        {
            key: 'Name',
            text: I18N.TR('Alarmbezeichnung'),
        },
        {
            key: 'Cond',
            text: I18N.TR('Fehler/Bedingung'),
        },
        {
            key: 'Device',
            text: I18N.TR('Gerät'),
        },
        {
            key: 'Prio',
            text: I18N.TR('Priorität'),
            sortCol: 'order',
        },
        {
            key: 'Interval',
            text: I18N.TR('Zeitraum'),
            sortCol: 'order',
        },
        {
            key: 'None',
            text: I18N.TR('Nicht gruppieren'),
        },
    ],

    show: function (id, breadcrumbsView, triggerSidebar) {
        var self = this;
        HomeController.showBaseLayout({
            cb: function () {
                if (triggerSidebar) triggerSidebar.tab = 'alarm-list';
                else triggerSidebar = { req: 'sidebar:default', selected: 'alarm-list' };

                App.trigger(
                    triggerSidebar.req,
                    triggerSidebar.selected,
                    triggerSidebar.permissions,
                    triggerSidebar.tab
                );
                App.showContentView(
                    new AlarmGroupList({
                        controller: self,
                        groupSettings: self.groupSettings,
                        ownerID: id,
                    })
                );

                if (breadcrumbsView) {
                    AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                }
            },
        });
    },
});

module.exports = AlarmOccurrenceController;
